import { createFileRoute, Link } from "@tanstack/react-router";
import { MarkLast, ReadingPage, readingBody, readingEyebrow, readingH1, readingH2, readingLink, readingSection, readingUpdated } from "@/components/public/reading-page";
import { RouteError, RouteNotFound } from "@/components/route-boundaries";
import { LegalBlock, legalHead } from "@/components/public/legal-page";
import { CONTACT_EMAIL } from "@/lib/legal/seller";

export const Route = createFileRoute("/_public/editorial-policy")({
  head: () =>
    legalHead(
      "/editorial-policy",
      "سياسة التحرير",
      "مين بيكتب مقالات المدوّنة، على أي منهج تُبنى، مصادرها، وكيف تبلّغ عن خطأ.",
    ),
  errorComponent: RouteError,
  notFoundComponent: RouteNotFound,
  component: EditorialPolicyPage,
});

const sections = [
  {
    title: "مين بيكتب",
    body: "تُنشر المقالات باسم د. سارة النحّاس (دكتوراه في التربية – جامعة دمشق) وتحت إشرافها، وتُبنى على المنهج المذكور في صفحة «من نحن»: علم النفس التطوّري، نظرية التعلّق، والتربية الإيجابية القائمة على البحث.",
  },
  {
    title: "المصادر",
    body: "نعتمد على الأبحاث والمراجع العلمية في علم النفس التربوي والنمائي، وعلى خبرة العمل مع الأهل والأطفال. نوضّح في المقال متى تكون المعلومة رأياً تربوياً وليست نتيجة بحث.",
  },
  {
    title: "التصحيحات والإبلاغ عن خطأ",
    body: `إذا لاحظت خطأ أو معلومة تحتاج تحديث، راسلنا على ${CONTACT_EMAIL} مع رابط المقال. نراجع الملاحظة، ونصحّح المقال إذا لزم، ونحدّث تاريخ «آخر تحديث» فيه.`,
  },
  {
    title: "المحتوى المموَّل",
    body: "لا ننشر مقالات مدفوعة أو مموَّلة. إذا تغيّر هذا يوماً، سيحمل أي محتوى من هذا النوع علامة «إعلان» واضحة.",
  },
];

function EditorialPolicyPage() {
  return (
    <ReadingPage
      header={
        <>
            <p className={readingEyebrow}>سياسة التحرير</p>
            <h1 className={readingH1}><MarkLast text="سياسة التحرير" /></h1>
            <p className={readingUpdated}>آخر تحديث: تشرين الأول 2026</p>
        </>
      }
    >
      <div className="mt-10 space-y-8">
        {sections.map((s, i) => (
          <LegalBlock key={s.title} {...s} className={(i < 2 ? "" : "reveal ") + readingSection} />
        ))}
      </div>
      <p className="mt-8 text-[14px] text-brown-500">
        المزيد عن د. سارة في{" "}
        <Link to="/about" className="font-bold text-amber-800 underline underline-offset-4">صفحة «من نحن»</Link>.
      </p>
    </ReadingPage>
  );
}
